// extracted by mini-css-extract-plugin
export default {"Footer":"style_Footer__z2cjX","copyright":"style_copyright__fJmDV","logo":"style_logo__ZhoQK","social":"style_social__8I5l5","circle":"style_circle__jeLfV"};